import React from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody, ModalFooter } from '../../..';
import { useModal } from '../../../../hooks';
import styles from './UpgradeMethodModal.module.scss';
import {
  CloseOutlinedIcon,
  CommercialPackageIcon,
  ProfessionalPackageIcon,
} from '../../../../assets/icons';

import ModalHeader from '../../../Modal/ModalHeader';
import {
  redirectToPaymentPort,
  splitPriceByThree,
  // redirectToPaymentPortEng,
} from '../../../../utils';
import Radio from '../../../Form/Radio';
import { useEffect } from 'react';
import {
  setSelectedUpgradeMethod,
  setIsAutoUpgradeVisible,
  dispalySelectBankModalStart,
  // makePaymentWithoutOfficialBill,
  // setIsSelectBankVisible,
} from '../../../../redux/payments/payments.actions';
import { LineWave } from 'react-loader-spinner';
import useTranslation from 'hooks/useTranslation';
import { capitalizeFirstLetter } from 'utils/text';
import { getArrayOfInfoBasedOnUserType } from 'redux/payments/payments.adapter';

const mapState = (state) => ({
  selectedPackage: state.paymentsData.selectedPackage,
  selectedDuration: state.paymentsData.selectedDuration,
  payablePrice: state.paymentsData.payablePrice,
  isAutoUpgradeVisible: state.paymentsData.isAutoUpgradeVisible,
  selectedUpgradeMethod: state.paymentsData.selectedUpgradeMethod,
  invoiceId: state.paymentsData.invoiceId,
  paymentInfo: state.paymentsData.paymentInfo,
  displayInputPaymentInfoModal: state.paymentsData.displayInputPaymentInfoModal,
  isOfficialBillNeeded: state.paymentsData.isOfficialBillNeeded,
  discountCode: state.paymentsData.discountCode,
  useCredit: state.paymentsData.useCredit,
  selectedConversationCount: state.paymentsData.selectedConversationCount,
  makeInvoiceLoading: state.paymentsData.makeInvoiceLoading,
  packages: state.paymentsData.packages.data,
  locale: state.appData.locale,
});

const UpgradeMethodModal = ({
  isPackageUpgrade,
  onToggle,
  renderCta,
  toggleUserInfoModalVisible,
  onCloseUpgradeMethodModal,
}) => {
  const dispatch = useDispatch();
  const {
    selectedPackage,
    selectedDuration,
    payablePrice,
    isAutoUpgradeVisible,
    selectedUpgradeMethod,
    invoiceId,
    makeInvoiceLoading,
    packages,
    locale,
    paymentInfo,
    // isOfficialBillNeeded,
    // discountCode,
    // useCredit,
    // selectedConversationCount,
  } = useSelector(mapState);
  const [visible, , hideModal, showModal] = useModal();
  const { getAppLocale, getTranslation } = useTranslation('PACKAGE_UPGRADING');
  const { t } = getTranslation();

  // box for reviewing info before proceeding
  const renderInfoReviewBox = () => {
    const infoData = paymentInfo.data;
    const anyInfoData = infoData && Object.keys(infoData).length !== 0;

    if (!anyInfoData) return null;

    const formData = getArrayOfInfoBasedOnUserType(infoData);

    const dataBox = formData?.map(
      (item, index) =>
        item && (
          <div key={index} className={styles.databox__item}>
            <span>{item.label} : </span>
            <b className={styles.user_info__value}>{item.value}</b>
          </div>
        )
    );

    return (
      <div className={styles.info_review__wrapper}>
        <div className={styles.info_review}>
          <div className='flex flex-column'>
            <h2>اطلاعات</h2>
            <div>
              <div className={styles.databox}>{dataBox}</div>
              <button
                className={clsx(['btn btn-primary', styles.edit_info_btn])}
                onClick={toggleUserInfoModalVisible}
              >
                {t('INFO_EDIT_BTN')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const displaydPackage = packages
    ? packages[selectedPackage]?.name[getAppLocale()]
    : '';

  const handlePayment = () => {
    // if (locale === 'en') {
    //   redirectToPaymentPortEng(invoiceId);
    //   return;
    // }
    redirectToPaymentPort(invoiceId);
  };

  const dispaySelectBankModalHandler = (event) => {
    dispatch(dispalySelectBankModalStart({ handleToggleModal }));
  };

  const selectUpgradeMethodHandler = (event) => {
    dispatch(setSelectedUpgradeMethod(event.target.value));
  };

  const handleToggleModal = (event) => {
    if (event) event.preventDefault();
    dispatch(setIsAutoUpgradeVisible(false));
    onCloseUpgradeMethodModal();
    hideModal();
  };

  const renderAutomaticWithdrawOption = locale === 'fa' && (
    <div>
      <Radio
        label={t('SERVICE_AUTO_RENEWAL')}
        value='auto'
        checkedValue={selectedUpgradeMethod}
        onChecked={selectUpgradeMethodHandler}
      />
    </div>
  );

  useEffect(() => {
    if (isAutoUpgradeVisible) {
      showModal();
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAutoUpgradeVisible]);

  // TODO: refactos buttons. link tag does not seem a good choice
  const renderFooterActions = (
    <div className='modal__container__footer__right'>
      {selectedUpgradeMethod === 'manual' && (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a
          href='#'
          className='btn primary'
          id='saveClose'
          onClick={handlePayment}
        >
          {t('REDIRECT_TO_PAYMENT_GATEWAY')}
        </a>
      )}
      {selectedUpgradeMethod !== 'manual' && (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a
          href='#'
          className='btn primary'
          id='saveClose'
          onClick={dispaySelectBankModalHandler}
        >
          {t('CONTINUE_PURCHASE')}
        </a>
      )}
    </div>
  );

  return (
    <>
      {renderCta && (
        <button className={styles.button} onClick={onToggle}>
          {t('CONTINUE_PURCHASE')}
        </button>
      )}
      {makeInvoiceLoading && (
        <div className={styles.overlay}>
          <LineWave
            height={120}
            width={120}
            color='rgb(177, 14, 132)'
            ariaLabel='line-wave'
            wrapperStyle={{}}
            wrapperClass=''
            visible={true}
          />
        </div>
      )}
      <Modal visible={visible}>
        <form noValidate>
          <ModalHeader
            title={
              isPackageUpgrade
                ? t('CHOOSE_HOW_TO_RENEWAL')
                : t('CHECK_USER_INFO_HEADER')
            }
          >
            <img
              className={styles.closeIcon}
              src={CloseOutlinedIcon}
              alt=''
              onClick={handleToggleModal}
            />
          </ModalHeader>
          <ModalBody>
            <section className={styles.upgradeMethodWrapper}>
              {isPackageUpgrade && (
                <>
                  <div className={styles.packageWrapper}>
                    <div className={styles.imageWrapper}>
                      <div className={styles.icon}>
                        <img
                          src={
                            selectedPackage === 'commerical'
                              ? ProfessionalPackageIcon
                              : selectedPackage === 'premium'
                              ? CommercialPackageIcon
                              : CommercialPackageIcon
                          }
                          alt=''
                        />
                      </div>
                      <div>
                        {getAppLocale() === 'fa'
                          ? `${t('SERVICE')} ${displaydPackage}`
                          : ` ${capitalizeFirstLetter(displaydPackage)} ${t(
                              'SERVICE'
                            )}`}
                      </div>
                    </div>
                    <div>
                      {selectedDuration === 'yearly'
                        ? t('YEARLY')
                        : selectedDuration === 'triennial'
                        ? t('TRIENNIAL')
                        : selectedDuration === 'quarterly'
                        ? t('QUARTERLY')
                        : t('MONTHLY')}
                    </div>
                    <div className={styles.totalPrice}>{`${splitPriceByThree(
                      Math.round(payablePrice)
                    )} ${
                      getAppLocale() === 'fa' ? t('TOOMAN') : t('UNIT')
                    }`}</div>
                  </div>
                  <div className={styles.selectUpgradeMethod}>
                    <div>
                      <Radio
                        label={t('SERVICE_MANUAL_RENEWAL')}
                        value='manual'
                        checkedValue={selectedUpgradeMethod}
                        onChecked={selectUpgradeMethodHandler}
                      />
                    </div>
                    {renderAutomaticWithdrawOption}
                    <p>{t('SERVICE_AUTO_RENEWAL_DESCRIPTION')}</p>
                  </div>
                </>
              )}
              {renderInfoReviewBox()}
            </section>
          </ModalBody>
          <ModalFooter>{renderFooterActions}</ModalFooter>
        </form>
      </Modal>
    </>
  );
};

export default UpgradeMethodModal;
